// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"afcf472c","45":"b76dc251","60":"a3e46859","361":"99e62eac","444":"385b0edb","496":"ef5e9446","603":"a10294c3","867":"6e91d5bf"}[chunkId] + ".chunk.js";
};